export default __webpack_public_path__ + "static/media/002-anteater.36df6035.svg";